import { render } from "./DictionaryFieldContents.vue?vue&type=template&id=5181abbf&scoped=true&ts=true"
import script from "./DictionaryFieldContents.vue?vue&type=script&lang=ts"
export * from "./DictionaryFieldContents.vue?vue&type=script&lang=ts"

import "./DictionaryFieldContents.vue?vue&type=style&index=0&id=5181abbf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5181abbf"]])

export default __exports__